import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {handleGetSectionMessages, handleLanguageChange, MessagesState} from "../reducers/messages-reducers";
import messagesService from "../../services/messages.service";

export const getSectionMessages = createAsyncThunk(
    'getSectionMessages',
    async (sectionName: string, thunkApi) => {
        return await messagesService.getSectionMessages(sectionName, (thunkApi.getState() as any)['messagesReducer'].languageId)
            .then(response => ({sectionName, messages: response != null ? response.messages : []}));
    },
    {
        condition(thunkData, {getState}): boolean {
            const state = getState() as any; //TODO: bad code
            return !state["messagesReducer"].messageCache[thunkData.valueOf()];
        }
    }
)

export const messagesSlice = createSlice({
    name: "messages",
    initialState: {
        messageCache: {},
        languageId: 1
    } as MessagesState,
    reducers: {
        changeLanguage: handleLanguageChange,
    },
    extraReducers: (builder) => {
        builder.addCase(getSectionMessages.fulfilled, (state, action) => handleGetSectionMessages(state, action.payload));
    }
})

export default messagesSlice.reducer;
export const {changeLanguage} = messagesSlice.actions;
